// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Pagination .pagination .page-item:first-child .page-link{border-top-left-radius:50px;border-bottom-left-radius:50px}.Pagination .pagination .page-item:last-child .page-link{border-top-right-radius:50px;border-bottom-right-radius:50px}", ""]);
// Exports
module.exports = exports;
